// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__eIGJP","question":"Question_question__34D0G","description":"Question_description__3Dcjc"};